import React, { Component } from 'react';
import SvgRender from 'components/helpers/SvgRender';

import { withRouter, NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { NavItem, Dropdown, DropdownMenu, DropdownToggle } from 'reactstrap';

import logout from 'assets/svg/logout.svg';
import profile from 'assets/svg/profile.svg';
import dashboard from 'assets/svg/dashboard.svg';
import noTextLogo from 'assets/svg/notext_logo.svg';
import avatar from 'assets/svg/default_avatar.svg';

import { getAccount } from 'views/account/_selectors';

class PrivateHeader extends Component {
  constructor() {
    super();

    this.state = {
      isDropdownOpen: false,
      className: ''
    };
  }

  _mounted = false;

  toggleDropdown = () => {
    if (this._mounted) {
      this.setState(prevState => ({
        isDropdownOpen: !prevState.isDropdownOpen
      }));
    }
  };

  listenScrollEvent = e => {
    if (this._mounted) {
      this.setState({ className: window.scrollY >= 30 ? 'active' : '' });
    }
  };

  componentDidMount() {
    this._mounted = true;
    window.addEventListener('scroll', this.listenScrollEvent);
  }

  componentWillUnmount() {
    this._mounted = false;
    window.removeEventListener('scroll', this.listenScrollEvent);
  }

  render() {
    const { account, title } = this.props;

    return (
      <div
        className={`private-header align-items-center justify-content-between public-hide ${
          this.state.className
        }`}
      >
        {title ? <h1 className="title m-0">{title}</h1> : null}
        <NavItem className="drop-container">
          <div
            className={`nav-avatar img-circle d-flex ${!account.photo ? 'default' : ''}`}
            style={{
              backgroundImage: `url(${account.photo ? account.photo : avatar})`
            }}
          />

          <Dropdown isOpen={this.state.isDropdownOpen} toggle={this.toggleDropdown}>
            <DropdownToggle caret className="border-0 drop-title px-2">
              {!account ? '' : account.name}
            </DropdownToggle>
            <DropdownMenu right tag="div">
              {this.props.location.pathname != '/' ? (
                <NavLink
                  activeClassName="public-active"
                  to="/"
                  className="dropdown-item d-flex reverse"
                >
                  <SvgRender
                    path={noTextLogo}
                    style={{ height: 15 }}
                    svgClassName="white-svg"
                    className="mr-1"
                  />
                  Public site
                </NavLink>
              ) : (
                <NavLink to="/channels" tag="li" className="dropdown-item d-flex reverse">
                  <SvgRender path={dashboard} svgClassName="white-svg" className="mr-1" />
                  <span>Go to Dashboard</span>
                </NavLink>
              )}

              <NavLink to="/profile" className="dropdown-item d-flex reverse">
                <SvgRender path={profile} svgClassName="white-svg" className="mr-1" />
                <span>Profile</span>
              </NavLink>
              <div className="dropdown-divider" />
              <NavLink to="/logout" className="dropdown-item d-flex reverse last">
                <SvgRender path={logout} svgClassName="white-svg" className="mr-1" />
                <span>Logout</span>
              </NavLink>
            </DropdownMenu>
          </Dropdown>
        </NavItem>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { account: getAccount(state) };
}

export default withRouter(
  connect(
    mapStateToProps,
    {}
  )(PrivateHeader)
);



// WEBPACK FOOTER //
// ./src/components/layouts/PrivateHeader.js